/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_abc2ddd3{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline}.root_abc2ddd3 .dropdown_abc2ddd3{margin-bottom:0;margin-left:5px}\n"}]);
export const root = "root_abc2ddd3";
export const dropdown = "dropdown_abc2ddd3";